module.exports = __webpack_public_path__ + "img/thumbnail_Alpaca_j_normal.05c70a31.png";